import { logUsage } from 'owa-analytics';
import datapoints from '../datapoints';
import getFolderViewStateFromId from 'owa-mail-folder-store/lib/selectors/getFolderViewStateFromId';
/**
 * Logs the root folder click and its current expansion state.
 * @param distinguishedFolderId
 */
export default function logRootFolderNodeClick(distinguishedFolderId) {
    var localViewState = getFolderViewStateFromId(distinguishedFolderId);
    var _a = datapoints.ToggleFolderExpansion.datapoint, eventName = _a.name, customData = _a.customData;
    logUsage(eventName, customData(distinguishedFolderId, localViewState.isExpanded));
}
//# sourceMappingURL=logRootFolderNodeClick.js.map